import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import EncoderAPI from "../../api/EncoderAPI";
import LiveTimeline from "./LiveTimeline";

function LiveCalendar() {
  const language = useSelector((state) => state.variableReducer.lang);

  const getLivesStatsQuery = EncoderAPI.generateQuery({
    fn: EncoderAPI.getLivesStats,
    params: [],
  });

  const { data: futureLives } = useQuery(getLivesStatsQuery);

  const data = futureLives?.data;

  if (!data || !data.length) return null;

  const history = useHistory();

  const handleClick = ({ uuid }) => {
    history.push(`live/${uuid}`);
  };

  const itemList = data?.map((item) => {
    const {
      media_uuid: uuid,
      live_start: liveStart,
      max_quality: maxQuality,
      live_start: startDate,
      media_label: label,
      status,
      duration,
      media_pictures: mediaPictures,
    } = item;

    const picture =
      mediaPictures?.cover_picture_16_9 ||
      mediaPictures?.cover_picture_16_6 ||
      mediaPictures?.cover_picture_3_4 ||
      mediaPictures?.cover_picture_1_1;

    return {
      uuid,
      startDate,
      maxQuality,
      label,
      duration,
      liveStart,
      status,
      picture,
    };
  });

  return (
    <LiveTimeline
      itemList={itemList}
      onClick={handleClick}
      language={language}
    />
  );
}

export default LiveCalendar;
